module.exports = __webpack_public_path__ + "img/Keshavarzi.16e696de.svg";